angular.module('leanlaw').controller('ContingencyExpenseReportSidebarCtrl', ['$scope', '$rootScope', '$q', '$filter', '$stateParams', '$state', "alerts", function ($scope, $rootScope, $q, $filter, $stateParams, $state, alerts) {
  $scope.years = [];
  for (var i = 0; i < 10; i++) {
    const year = new Date().getFullYear() - i;
    $scope.years.push({
      label: year,
      startDate: new Date(year, 0, 1).toNetworkDate(),
      endDate: new Date(year + 1, 0, 0).toNetworkDate()
    });
  }
  $scope.periods = [{
    id: 'ytd',
    label: 'Year-to-Date by Month',
    period: 'month',
    range: {
      startDate: new Date(new Date().getFullYear(), 0, 1).toNetworkDate(),
      endDate: new Date().toNetworkDate()
    }
  }, {
    id: 'lastYear',
    label: 'Last Year by Month',
    period: 'month',
    range: {
      startDate: new Date(new Date().getFullYear() - 1, 0, 1).toNetworkDate(),
      endDate: new Date(new Date().getFullYear(), 0, 1).toNetworkDate()
    }
  }, {
    id: 'months',
    label: 'Last 12 Months',
    period: 'month',
    range: {
      startDate: new Date(new Date().getFullYear() - 1, new Date().getMonth() + 1, 1).toNetworkDate(),
      endDate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toNetworkDate()
    }
  }, {
    id: 'quarter',
    label: 'Quarters',
    period: 'quarter',
    range: {
      startDate: new Date(new Date().getFullYear() - 1, 0, 1).toISOString(),
      endDate: new Date().toISOString()
    }
  }, {
    id: 'year',
    label: 'Years',
    period: 'year',
    range: {
      startPeriod: $scope.years[4],
      endPeriod: $scope.years[0]
    }
  }];
  $scope.filter = {
    period: $scope.periods.find(p => p.id === 'year'),
    include: {
      matters: false
    }
  };
  $scope.filter.range = $scope.filter.period.range;
  $scope.filter.include.matters = false;

  // Fires immediately on filter creation
  $scope.$watch("filter", (newValue, oldValue) => {
    $rootScope.$broadcast("report-sidebar-filterchange", $scope.filter);
  }, true);
}]);